// 首页
import request from '@/utils/request'

// 文档详情
export function detailDoc(params) {
  return request({
    url: '/v3/manager/onlineHandbook/menuDetail',
    method: 'post',
    data: params
  })
}

// 新增文档
export function addDoc(params) {
  return request({
    url: '/v3/manager/onlineHandbook/addMenu',
    method: 'post',
    data: params
  })
}

// 修改文档
export function editDoc(params) {
  return request({
    url: '/v3/manager/onlineHandbook/editTitleContent',
    method: 'post',
    data: params
  })
}

// 删除文档
export function deleteDoc(params) {
  return request({
    url: '/v3/manager/onlineHandbook/deleteMenu',
    method: 'post',
    data: params
  })
}

// 分类接口
export function getTypeList(params) {
  return request({
    url: '/v3/manager/onlineHandbook/getTypeList?platform=' + params,
    method: 'post'
  })
}

// 获取分类
export function platformListLang(lang) {
  return request({
    url: '/v3/manager/onlineHandbook/platformListLang',
    method: 'post',
    headers: { 'language': lang }

  })
}
// 获取分类下的标题
export function platformMenuList(params) {
  return request({
    url: '/v3/manager/onlineHandbook/platformMenuList',
    method: 'post',
    data: params
  })
}
